import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ScrollToTop from './ScrollToTop'; 
import HomeV3 from './pages/landing/v3/home/home.component';
import Partners from './pages/partners/partners.component';
import News from './pages/news/news.component';
import NewsInner from './pages/news/newsinner/newsinner.component';
import ThankYouPage from './pages/thankyou/thankyou';
import TermsOfServices from './pages/termsofservices/termsofservices.component';
import PrivacyPolicy from './pages/privacypolicy/privacypolicy.component';
import Features from './pages/features/features.component';
import Solutions from './pages/solutions/solutions.component';
import AIQualityProgram from './pages/solutions/ai-quality-program/aiquality.component';
import About from './pages/about/about.component';
import Careers from './pages/careers/careers.component';
import CookiePolicy from './pages/cookiepolicy/cookiepolicy.component';
import AcceptableUse from './pages/acceptableuse/acceptableuse.component';
import Oculo from './pages/apps/oculo/oculo.component';
import PrimePage from './pages/apps/prime/prime.component';


function App() {
  return (
    <>
      <ScrollToTop /> {/* Include ScrollToTop */}
      <Routes>
        <Route path="/" element={<HomeV3 />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:postSlug" element={<NewsInner />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/terms-of-services" element={<TermsOfServices />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/features" element={<Features/>} />
        <Route path="/solutions" element={<Solutions/>} />
        <Route path="/solutions/ai-quality-program" element={<AIQualityProgram/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/careers" element={<Careers/>} />
        <Route path="/cookie-policy" element={<CookiePolicy/>} />
        <Route path="/acceptable-use" element={<AcceptableUse/>} />
        <Route path="/apps/oculo" element={<Oculo/>} />
        <Route path="/apps/prime" element={<PrimePage/>} />
      </Routes>
    </>
  );
}

export default App;
